<template>
  <div class="pb-3">
    <vue-editor 
      height="250"
      :placeholder="$t('job.form.summary.placeholder')"
      v-model="model.note"
    />
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    VueEditor
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      model: {
        note: ''
      }
    }
  },
  watch: {
    'parameters.submitted': function() {
      this.model.note = ''
    }
  }
}
</script>